module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.library.js
 ** module id = 181
 ** module chunks = 0
 **/